export default (el, binding) => {
  console.log("binding.value.color EL", el); // => "white"
  console.log("Bin", binding); // => "hello!"
};
